import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class GradeReferenceService extends BaseReferenceService {
  constructor() {
    super('GradeReference');
  }
}
